module.exports = __webpack_public_path__ + "img/ccnsw.7d2573c.png";